import request from '@/router/axios'
// 菜单树形
export function menuTree(query) {
    return request({
      url: '/articleMenu/tree',
      method: 'post',
      params: query
    })
  }
  // 菜单增加
export function menuInsert(query) {
  return request({
    url: '/articleMenu/insert',
    method: 'post',
    params: query
  })
}
  // 菜单修改
  export function menuUpdate(query) {
    return request({
      url: '/articleMenu/update',
      method: 'post',
      params: query
    })
  }
  // 菜单列表
  export function menuList(query) {
    return request({
      url: '/articleMenu/',
      method: 'post',
      params: query
    })
  }
   // 菜单删除
   export function menuDelete(query) {
    return request({
      url: '/articleMenu/del',
      method: 'post',
      params: query
    })
  }
  // 查询所有模板
  export function menugetAllTemplate(query) {
    return request({
      url: '/articleMenu/getAllTemplate',
      method: 'post',
      params: query
    })
  }
